import React, { Component } from 'react';

import { Container, Offcanvas, Row, Col,  Form, Tabs, Tab } from 'react-bootstrap';

import CommonInput from '../components/CommonInput';
import CommonSelect from '../components/CommonSelect';
import CommonFile from '../components/CommonFile';
import CustomDatePicker from "../components/CommonDatePicker";
import CommonButton from '../components/CommonButton';

import CommonAlert from '../components/CommonAlert';
import CommonLoadingBar from '../components/CommonLoadingBar';

import * as Actions from '../actions/ActionCenter';

import * as fn from '../../library/function';
import * as helper from '../../library/helper';
import * as util from '../../library/utilitys';

import SimpleBar from 'simplebar-react';

import InlineTypeAEnterprise from '../inline/InlineTypeAEnterprise';
import InlineTypeAEnterpriseWelfare from '../inline/InlineTypeAEnterpriseWelfare'
class InputTypeADuolCoop extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedDate: new Date(),
            activeTab: 'profile',
            DrillDowns: {
                type_a_new_student_dual_coop_profile: {
                    drilldown: false,
                    fk: null,
                    val: null,
                    page: null
                },   
                type_a_new_student_dual_coop_welfare: {
                    drilldown: false,
                    fk: null,
                    val: null,
                    page: null
                },                        
            }              
        };
    }

    handleDateChange = (date) => { this.setState({ selectedDate: date }); }

    handleTabSelect = (key) => { this.setState({ activeTab: key }); };       

    prepareInputs = async () => {
        const { URL, Action, Inputs, onUpdateState } = this.props;
        const isUpdateMode = Action.Mode === 'update';

        let updatedInputs = fn.setRequiredPrimaryKey(Inputs, isUpdateMode);

        onUpdateState('Inputs', updatedInputs);
    }

    drillDownInline = ({key, fk = null, val = null, page = null, drilldown = false, restore = {}}) => {
        this.setState(prevState => {
            const updatedDrillDowns = {
                ...prevState.DrillDowns,
                [key]: { 
                    drilldown : true, fk, val, page 
                }
            };

            if (key === 'type_a_new_student_dual_coop_welfare' && prevState.DrillDowns.type_a_new_student_dual_coop_profile) {
                updatedDrillDowns.type_a_new_student_dual_coop_profile = {
                    ...prevState.DrillDowns.type_a_new_student_dual_coop_profile,
                    drilldown: false
                };
            }

            return {
                ...prevState,
                DrillDowns: updatedDrillDowns
            };
        }, () => {
            console.log("debugging drilldown inline =", this.state);
        });            
    }

    drillUpInline = ({key}) => {
        this.setState(prevState => {
            
            const updatedDrillDowns = {
                ...prevState.DrillDowns,
                [key]: {
                    drilldown: false,
                    fk: null,
                    val: null,
                    page: null,
                }
            }; 
            
            if (key === 'type_a_new_student_dual_coop_welfare' && prevState.DrillDowns.type_a_new_student_dual_coop_profile) {
                updatedDrillDowns.type_a_new_student_dual_coop_profile = {
                    ...prevState.DrillDowns.type_a_new_student_dual_coop_profile,
                    drilldown: true
                };
            }   
            
            return {
                ...prevState,
                DrillDowns: updatedDrillDowns
            };
        }, () => {
            console.log("debugging drillup inline =", this.state);
        });              
    }

    componentDidUpdate = async (prevProps) => {
        if (fn.shouldPrepareInputs(prevProps.Action, this.props.Action)) {
            await this.prepareInputs();
        }
    }

    render = () => {
        let props = this.props;

        let { onInputChange, onCloseAlert, onSubmit, onDiscardSubmit, onSetEdit, onPreviewFile, onDeleteFile } = props;

        let { App, Action, Inputs, InputGroup , Operation, Masterbase } = props;

        let { DrillDowns } = this.state;

        let { Submit } = Operation;
        
        let { show, mode } = Action.OffCanvas;

        let isLoading = Action.Loading.submit;
    
        return (
                <Offcanvas 
                    show={show}
                    placement="end" 
                    style={{ '--bs-offcanvas-width': '100vw' }}
                    scroll={true}
                    backdrop={Submit ? "static" : true}
                    onHide={(e) => { 
                        this.setState({activeTab: 'profile'});
                        props.onClose(e);
                    }}
                >

                  <Offcanvas.Header closeButton className="border-bottom custom-offcanvas-header">
                        <Offcanvas.Title className="custom-offcanvas-header offcanvas-title"><i className={`${App.icon} text-white me-2`}/>{App.title}</Offcanvas.Title>
                    </Offcanvas.Header>

                     <Offcanvas.Body className="custom-offcanvas-body p-0">
                        
                        <CommonAlert 
                            alert={Action.Alert} 
                            callback={(e) => onCloseAlert(e)}
                        />
                        
                        <SimpleBar id="inputs" className="simple-bar-input">

                            <Container fluid className="data-table-container">

                                <Tabs 
                                    defaultActiveKey="profile" 
                                    activeKey={this.state.activeTab}
                                    onSelect={(e) => this.handleTabSelect(e)}
                                    className="mb-3"
                                >  
                                    <Tab eventKey="profile" title="ข้อมูลนักศึกษา">
                                       { /* ปรับให้เพิ่มหลายสถานศึกษาพร้อมกัน */ }
                                        {/* <Row>
                                            <Col md={1} className="mb-3">{util.formatLabel(null, Inputs.academy_id)}</Col>
                                            <Col xs={10} sm={8} md={3} className="mb-3">
                                                <CommonSelect
                                                    element="Inputs"
                                                    input={Inputs.academy_id}
                                                    option={{source: 'db', data: Masterbase?.academy}}
                                                    hr={false}
                                                    floatingLabel={false}
                                                    callback={(e, element) => onInputChange(e, element)} 
                                                />                                  
                                            </Col>
                                        </Row>*/}
                                        <Row> 
                                            <Col md={1} className="mb-3">{util.formatLabel(null, Inputs.faculty_id)}</Col>
                                            <Col xs={10} sm={8} md={3} className="mb-3">
                                                <CommonSelect
                                                    element="Inputs"
                                                    input={Inputs.faculty_id}
                                                    option={{source: 'db', data: Masterbase?.faculty}}
                                                    hr={false}
                                                    floatingLabel={false}
                                                    callback={(e, element) => {
                                                        onInputChange(e, element);
                                                        onInputChange({ target: { name: 'department_id', value: '' } }, element);
                                                    }} 
                                                />                                  
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={1} className="mb-3">{util.formatLabel(null, Inputs.department_id)}</Col>
                                            <Col xs={10} sm={8} md={3} className="mb-3">
                                                <CommonSelect
                                                    element="Inputs"
                                                    input={Inputs.department_id}
                                                    option={{
                                                        source: 'db', 
                                                        data: 
                                                            Inputs.faculty_id.value !== '' ? 
                                                            Masterbase?.department.filter( (d) => d.faculty_id === Inputs.faculty_id.value )
                                                        : []
                                                    }}

                                                    hr={false}
                                                    floatingLabel={false}

                                                    callback={(e, element) => {
                                                        onInputChange(e, element);
                                                    }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={1} className="mb-3">{util.formatLabel(null, Inputs.education_level_id)}</Col>
                                            <Col xs={10} sm={8} md={3} className="mb-3">
                                                <CommonSelect
                                                    element="Inputs"
                                                    input={Inputs.education_level_id}
                                                    option={{source: 'db', data: Masterbase?.education_level}}
                                                    hr={false}
                                                    floatingLabel={false}
                                                    callback={(e, element) => onInputChange(e, element)} 
                                                />                                  
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={1} className="mb-3">{util.formatLabel(null, Inputs.target_industries_id)}</Col>
                                            <Col xs={10} sm={8} md={3} className="mb-3">
                                                <CommonSelect
                                                    element="Inputs"
                                                    input={Inputs.target_industries_id}
                                                    option={{source: 'db', data: Masterbase?.target_industries}}
                                                    hr={false}
                                                    floatingLabel={false}
                                                    callback={(e, element) => onInputChange(e, element)} 
                                                />                                  
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={1} className="mb-3">{util.formatLabel(null, Inputs.academic_year)}</Col>
                                            <Col xs={10} sm={8} md={3} className="mb-3">
                                                <CommonSelect
                                                    element="Inputs"
                                                    input={Inputs.academic_year}
                                                    option={{source: 'db', data: Masterbase?.yearBEOptions}}
                                                    hr={false}
                                                    floatingLabel={false}
                                                    callback={(e, element) => onInputChange(e, element)}
                                                />                             
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col md={1} className="mb-3">{util.formatLabel(null, Inputs.student_count)}</Col>
                                            <Col xs={10} sm={8} md={3} className="mb-3">
                                                <CommonInput
                                                    element="Inputs"
                                                    input={Inputs.student_count}
                                                    hr={false}
                                                    floatingLabel={false}
                                                    callback={(e, element) => onInputChange(e, element)} 
                                                    disabled={false}
                                                />                               
                                            </Col>
                                        </Row>
                                    </Tab>

                                    <Tab eventKey="academy_info" title="ข้อมูลสถานประกอบการ">
                                        {DrillDowns.type_a_new_student_dual_coop_welfare.drilldown === false && (        
                                            (console.log('log')),
                                            <Row>
                                                <Col md={{ span: 10, offset: 1 }} className="mb-3">                                    
                                                    <InlineTypeAEnterprise
                                                        fkId="type_a_new_student_dual_coop_id"
                                                        fkVal={Inputs.id.value}

                                                        onDrillDownInline={(e) => this.drillDownInline(e)}
                                                    />
                                                </Col>                                        
                                            </Row>           
                                        )}
                                        {DrillDowns.type_a_new_student_dual_coop_welfare.drilldown === true && (
                                            <Row>
                                                <Col md={{ span: 10, offset: 1 }} className="mb-3">                                 
                                                    <InlineTypeAEnterpriseWelfare
                                                        refKey='type_a_new_student_dual_coop_welfare'
                                                        refPage={DrillDowns.type_a_new_student_dual_coop_welfare.page}
                                                        
                                                        fkId="type_a_new_student_dual_coop_profile_id"
                                                        fkVal={DrillDowns.type_a_new_student_dual_coop_welfare.val}

                                                        onDrillDownInline={(e) => this.drillDownInline(e)}
                                                        onDrillUpInline={(e) => this.drillUpInline(e)}                                                        
                                                    />
                                                </Col>                                        
                                            </Row>           
                                        )} 
                                    </Tab>

                                </Tabs>                          
                            </Container>                          
                            
                        </SimpleBar>

                    </Offcanvas.Body>  


                   { this.state.activeTab === 'profile' && (
                    <div className="offcanvas-footer d-flex flex-column border-top bg-light p-3">

                        <CommonLoadingBar isLoading={isLoading} />

                        <div className="d-flex justify-content-end mt-2">
                            <CommonButton 
                                task={mode} 
                                disabled={isLoading ? true : Submit ? false : true}
                                callback={async (e) => {
                                        let currentId = Inputs.id.value;
                                        await onSubmit(e);
                                        if (Action.Mode === 'update') {
                                            onSetEdit({}, {id: currentId}); 
                                        }
                                        this.handleTabSelect('profile');
                                }} 
                            />

                            {Action.Mode === 'new' && (
                                <CommonButton 
                                    task="discard" 
                                    inlineClass="ms-1" 
                                    disabled={isLoading} 
                                    callback={(e) => onDiscardSubmit(false)} 
                                />
                            )}
                        </div>
                    </div>       
                   ) }                                                                              

                </Offcanvas>  
        )
    }    
}

export default InputTypeADuolCoop;